import { Box, Paper, Typography } from '@mui/material'

function Error() {
    return (
        <Box sx={{
            width: '50vw',
            boxSizing: 'border-box',
        }}>
            <Paper sx={{
                padding: 4,
                bgcolor: 'var(--text-primary)',
                textAlign: 'center'
            }}>
                <Typography variant='h5' color='var(--background-primary)'>
                    Page not found
                </Typography>
            </Paper>
        </Box>
    )
}

export default Error